import { StyledInputNumber } from "@components/input-number/input-number.styles";
import { InputNumberProps } from "./input-number.types";

export const InputNumber = ({ onChange, value, min, disabled }: InputNumberProps) => {
	return <StyledInputNumber onChange={onChange} disabled={disabled} value={value} min={min} />;
};
